import classes from "./ClemStrategy.module.scss";
import DescriptionCard from "../../../Components/DescriptionCard/DescriptionCard";
import Savings from "../../../assets/icons/Savings";
import FactoryIcon from "../../../assets/icons/FactoryIcon";
import GavelIcon from "../../../assets/icons/GavelIcon";
import WaterEc from "../../../assets/icons/WaterEc";

const cardDescription = [
  {
    heading: "Transition Financing",
    description:
      "Raising transition financing with CLEM strategy funds and partnering with debt and equity players.",
    icon: <Savings />,
  },
  {
    heading: "Clean Energy Development",
    description:
      "Partnering with stakeholders to share expertise with the pgoal of achieving the best outcomes while keeping the cost low.",
    icon: <FactoryIcon />,
  },
  {
    heading: "Blockchain - driven Marketplace",
    description:
      "Sourcing readily available and credible clean energy capacities and low cost of capital.",
    icon: <GavelIcon />,
  },
  {
    heading: "Additional Cashflows",
    description:
      "Transition credits; Monetizing excess power from RE; Repurposing CFPP decommissioning locations",
    icon: <WaterEc />,
  },
];

const ClemStrategy = () => {
  return (
    <div className={classes["clem-stretegy-container"]}>
      <div className={classes["clem-stretegy-heading"]}>
        {" "}
        CLEM Strategy: We believe in <span>Making it Happen!</span>
      </div>

      <div className={classes["clem-stretegy-description-container"]}>
        <div className={classes["clem-stretegy-description"]}>
          Our 'Make it Happen' approach turns vision into action, because we
          believe in doing, not just talking.
        </div>
      </div>

      <DescriptionCard cardDescription={cardDescription} />
    </div>
  );
};

export default ClemStrategy;
